import { ResourceType } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { colorSystem, type CustomIconProps } from '@luminovo/design-system';
import { BotIcon, UserRoundIcon } from 'lucide-react';
import * as React from 'react';

export interface ResourceIconProps extends CustomIconProps {
    resourceType: ResourceType;
}

export const ResourceIcon = React.forwardRef<SVGSVGElement, ResourceIconProps>(function ResourceIcon(
    { resourceType, size = 20, color = colorSystem.neutral[7], ...props },
    ref,
) {
    switch (resourceType) {
        case ResourceType.Machine:
            return <BotIcon ref={ref} size={size} color={color} {...props} />;
        case ResourceType.Person:
            return <UserRoundIcon ref={ref} size={size} color={color} {...props} />;
        default:
            /* c8 ignore next */
            return assertUnreachable(resourceType);
    }
});
